import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import SideBar from "../common/sideBar";
import HeaderAdminpanel from "../common/HeaderAdminpanel";  
import { axiosInstnace as axios } from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import moment from "moment";
import DatePicker from "react-datepicker";

const OnlineOfflineSalesReport = (props) => {
  //Set the initial state
  const [reportBaseData, handleReportBaseData] = useState([]);
  const [reportSeriesData, handleReportSeriesData] = useState([]);

  const [filterGroupBy, handleFilterGroupBy] = useState('station');
  const [dateFilterType, handleDateFilterType] = useState('all');
  const [filterStartDate, handleFilterStartDate] = useState(undefined);
  const [filterEndDate, handleFilterEndDate] = useState(undefined);
  const [highchartStored, handleHighchartStored] = useState(undefined);
  
  
  
  useEffect(() => {
    dynamicallyAddHighchartScripts();

    // getDataAndDrawChart();

    getReportData();
    
  }, []);

  const getDataAndDrawChart = async () => {
    await getReportData();
    setTimeout(() => {
      // getBarChart();
    }, 1000);
  }


  const dynamicallyAddHighchartScripts = () => {

    const script1 = document.createElement("script");
    script1.src = "https://code.highcharts.com/highcharts.js";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src = "https://code.highcharts.com/modules/data.js";
    script2.async = true;
    document.body.appendChild(script2);


    const script3 = document.createElement("script");
    script3.src = "https://code.highcharts.com/modules/drilldown.js";
    script3.async = true;
    document.body.appendChild(script3);

    const script4 = document.createElement("script");
    script4.src = "https://code.highcharts.com/modules/exporting.js";
    script4.async = true;
    document.body.appendChild(script4);

    const script5 = document.createElement("script");
    script5.src = "https://code.highcharts.com/modules/export-data.js";
    script5.async = true;
    document.body.appendChild(script5);

    const script6 = document.createElement("script");
    script6.src = "https://code.highcharts.com/modules/accessibility.js";
    script6.async = true;
    document.body.appendChild(script6);
  }

  
  const validateFilters = () => {
    if( dateFilterType=='range' && (!filterStartDate || !filterEndDate)){
      return new Error('Start Date and End Date cannot be empty');
    }
  }
  
  const getReportData = async (filterBy = filterGroupBy, dateFilter = dateFilterType, dateStart = filterStartDate, dateEnd = filterEndDate) => {
    try {
      validateFilters();
      
      const reportData = await axios.get(`${endPoints.getOnlineVSOfflineReportData}?filterBy=${filterBy}&dateFilter=${dateFilter}&startDate=${dateFilter=='range'?moment(dateStart).valueOf():''}&endDate=${dateFilter=='range'?moment(dateEnd).valueOf():''}`);
      // debugger;
      if(reportData.data && reportData.data.data.data.reportData){
        getBarChart(reportData.data.data.data.reportData.data, reportData.data.data.data.reportData.series);
        // handleReportBaseData(reportData.data.data.data.reportData.data);
        // handleReportSeriesData(reportData.data.data.data.reportData.series);
      }
    } catch (error) {
        // handleMasterSplashScreens([]);
    }
  }

  const getBarChart = (repBaseData, repSeriesData) => {
    console.log('reportBaseData', repBaseData);
    console.log('reportSeriesData', repSeriesData);
    

    if(highchartStored){
      highchartStored.update({
        series: [
          {
            name: "Online vs Offline Sales",
            colorByPoint: true,
            data: repBaseData 
          }
        ],
        drilldown: {
          series: repSeriesData
        }
      });
      // storedChart.redraw();
    }else{
      let storedChart = Highcharts.chart('onlinevsoffline-bar', {
        chart: {
          type: 'pie'
        },
        title: {
          text: 'Online vs Offline Sales'
        },
        subtitle: {
          text: 'Click the slices to station based drilldown.'
        },
      
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
      
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y:.1f}%'
            }
          }
        },
      
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
        },
      
        series: [
          {
            name: "Online vs Offline Sales",
            colorByPoint: true,
            data: repBaseData 
          }
        ],
        drilldown: {
          series: repSeriesData
        }
      });

      handleHighchartStored(storedChart);
    }

    return (
      <div>
        {
          storedChart      
        }

        {
          Highcharts.setOptions({
            colors: Highcharts.map(Highcharts.getOptions().colors, function (color) {
                return {
                    radialGradient: {
                        cx: 0.5,
                        cy: 0.3,
                        r: 0.7
                    },
                    stops: [
                        [0, color],
                        [1, Highcharts.color(color).brighten(-0.3).get('rgb')] // darken
                    ]
                };
            })
          })
        }
      </div>
    )
  }

  const offlinePageStyles = {
    filterFlexContainer: {
      display: "flex",
      flexDirection: "row",
      padding: "1.5em"
    },
    filterItemContainers: {
      width: "50%"
    },
    filterGroupByItemContainer: {

    },
    filterDateItemContainer: {
      display: "flex"
    }
    
  };
  
  
  return (
    <div className="dashboardContainer">
       <HeaderAdminpanel/>

      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar role={localStorage.getItem("adminRole")} />
        </section>
        <section id="dashboard-rightContainer" className="dashboard-manageSales">
          <div className="container-head">
            <div className="dashboard-breadcrumb">
              Reports |<span className="breadcrumb-active fct-breadcrumb">Online vs Offline Sales</span>
            </div>
          </div>
          <div className="dashboard-content userListing-dashboard bg-white">
            <div className="filters">
              <div className="row" style={offlinePageStyles.filterFlexContainer}>
                <div className="col" style={offlinePageStyles.filterItemContainers}>
                  <label style={{ display: "block" }}>Report Type</label>
                  <select className="packageType drop-down-icon" onChange={ (e)=> {
                    handleFilterGroupBy(e.target.value)
                    getReportData(e.target.value);
                    // setTimeout(getReportData, 10);
                    }}>
                    {/* <option value="">Generate report based on Station</option> */}
                    <option value="station">Generate report based on Station</option>
                    <option value="status">Generate report based on Campaign Status</option>
                  </select>
                </div>
                <div className="col" style={offlinePageStyles.filterDateItemContainer}>
                  <div>
                    <label style={{ display: "block" }}>Date filter</label>
                    <select className="packageType drop-down-icon" onChange={
                      (e)=> {
                        handleDateFilterType(e.target.value);
                        getReportData(filterGroupBy, e.target.value)
                        // setTimeout(getReportData, 1000);
                      }
                    }>
                      <option value="all">All-time</option>
                      <option value="lastquarter">Last Quarter</option>
                      <option value="lastmonth">Last Month</option>
                      <option value="range">Custom date</option>
                    </select>
                  </div>
                  { dateFilterType && dateFilterType == 'range' && (
                    <React.Fragment>
                      <div className="startDate">
                        <label>Start Date</label>
                        <DatePicker
                          selected={filterStartDate}
                          onChange={(date) => { handleFilterStartDate(date); getReportData(filterGroupBy, dateFilterType, date, filterEndDate); }}
                          dateFormatCalendar={"MMM yyyy"}
                          placeholderText=" Date"
                          // maxDate={endDate}
                          isClearable
                        />
                      </div>

                      <div className="endDate">
                        <label>End Date</label>
                        <DatePicker
                          selected={filterEndDate}
                          onChange={(date) => { handleFilterEndDate(date); getReportData(filterGroupBy, dateFilterType, filterStartDate, date);}}
                          dateFormatCalendar={"MMM yyyy"}
                          placeholderText=" Date"
                          // maxDate={endDate}
                          isClearable
                        />
                      </div>
                    </React.Fragment>
                  ) }
                  
                </div>
              </div>
            </div>
            <div id="onlinevsoffline-bar"></div>
          </div>

          <ToastContainer />
        </section>
      </div>
    </div>
  );
};

export default connect(null, {})(OnlineOfflineSalesReport);



// WEBPACK FOOTER //
// ./web/components/admin/reports/onlineoffline.js